import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { detailsList, invoiceData, paymentList } from './api';

const initialState = {
  loading: false,
  user_data: [],
  payment_data: []
};

const actions = {
  GET_BYID: 'get_byID/GET_BYID',
  GET_INVOICE_DATA: 'get_Invoice_data/GET_INVOICE_DATA',
  GET_PAYMENT_LIST: 'get_paymentList/GET_PAYMENT_LIST'
};

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  const response = await detailsList(payload);
  return response;
});

// get_paymentList/GET_PAYMENT_LIST
export const get_paymentList = createAsyncThunk(
  actions.GET_PAYMENT_LIST,
  async (payload) => {
    const response = await paymentList('payment-history', payload);
    return response;
  }
);

// get_Invoice_data/GET_INVOICE_DATA
export const get_Invoice_data = createAsyncThunk(
  actions.GET_INVOICE_DATA,
  async (payload) => {
    // console.log('payload', payload);
    const response = await invoiceData('download-invoice', payload);
    return response;
  }
);

export const accessUser = createSlice({
  name: 'manageProfile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // get_paymentList
    builder
      .addCase(get_paymentList.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_paymentList.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        // console.log('slice_View123', action.payload);
        state.payment_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_paymentList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // get_Invoice_data
    builder
      .addCase(get_Invoice_data.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_Invoice_data.fulfilled, () => {
        // const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        // state.user_data = data;
        // console.log('slicelog', data);
      })
      .addCase(get_Invoice_data.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default accessUser.reducer;
